import SEOLandingTemplate from './SEOLandingTemplate';

export default function PlagiarismCheckerPage() {
  return (
    <SEOLandingTemplate
      title="AI Content Checker"
      metaTitle="Free AI Content Checker | Sungresh"
      metaDescription="Check whether text is likely AI-generated. Note: this tool checks for AI-generated patterns, not duplicate content against the web — see the FAQ for the difference."
      h1="Free AI Content Checker"
      sub="Check whether a piece of text reads as AI-generated, with a plain-language explanation and specific phrases flagged. Note: this checks for AI-writing patterns, not duplicate content matched against other web pages — see the FAQ below."
      keywords="ai content checker, ai detector, plagiarism checker"
      ctaLink="/checker"
      ctaText="Check Text Free"
      features={[
        { icon: '🤖', title: 'AI Likelihood Score', desc: 'A 0-100 score with reasoning' },
        { icon: '🔍', title: 'Flagged Phrases', desc: 'Specific words and patterns that read as AI-typical' },
        { icon: '✦', title: 'Rewrite Assist', desc: 'Rewrites flagged text to read more naturally' },
      ]}
      faqs={[
        { q: 'Does this check for duplicate content against other websites?', a: 'No — this tool analyzes writing patterns to estimate whether text was AI-generated. It does not crawl the web to check for copied or duplicate content. For that, you\'d need a dedicated plagiarism-matching service.' },
        { q: 'Why does duplicate content matter for SEO?', a: 'Google generally won\'t penalize you for accidental overlap, but publishing content that closely mirrors existing pages tends to rank worse simply because it offers nothing new — the search engine has no reason to prefer a copy over the original.' },
        { q: 'How do I make sure content is genuinely original?', a: 'The most reliable approach is writing from your own knowledge and experience. If you use AI assistance to draft, review and substantively edit the output rather than publishing it unchanged, and fact-check any claims it makes.' },
      ]}
    />
  );
}
